<div class="signup-success-container">
  <div class="content-wrapper">
    <div class="logo-section">
      <img class="logo" src="/assets/img/fleetoperate_logo.jpg" alt="FleetOperate Logo" />
    </div>
    
    <div class="success-content">
      <h1 class="success-title" [ngClass]="inviteType ? 'font-white' : 'font-gray'">{{ title }}</h1>
      <img src="/assets/images/successful-sign-up.png" class="success-image" alt="Success" />
      
      @if (!inviteType) {
        <div data-test="signup-success" class="message-section">
          <p class="activation-message">Please check your email for the activation link.</p>
          <p class="spam-message">If you don't see it in your inbox, check the spam folder and mark it as <strong>"Not Spam"</strong>.</p>
        </div>
      }
    </div>
    
    <div class="button-section">
      <button class="ok-button" mat-raised-button color="primary" type="submit" (click)="onSignUpSuccess()">
        OK
      </button>
    </div>
  </div>
</div>